module.exports = __webpack_public_path__ + "861c44f7.svg";